/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("application.settings", require("./rawicons/settings.icon.svg.js"));
IconRegistry.registerIcon("application.check_sign", require("./rawicons/check_sign.icon.svg.js"));
IconRegistry.registerIcon("application.cross_mark", require("./rawicons/cross_mark.icon.svg.js"));
IconRegistry.registerIcon("application.camera", require("./rawicons/camera.icon.svg"));
IconRegistry.registerIcon("common.varied_checked", require("./rawicons/varied-checked.svg.js"));
IconRegistry.registerIcon("common.eye", require("./rawicons/eye.icon.svg"));
IconRegistry.registerIcon("common.eye_hide", require("./rawicons/eye_hide.icon.svg"));
